
const importAll = context => {
  const map = {}

  for (const key of context.keys()) {
    const exportValue = context(key)
    for (const module in exportValue) {
      const apis = exportValue[module]
      for (const key in apis) {
        map[key] = apis[key]
      }
    }
  }
  return map
}

export default importAll(require.context('@/api/modules/', true, /\.js$/))
